module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate3.56d4466.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate3.png
// module id = 762
// module chunks = 0